"use strict";

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.array.filter.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

require("core-js/modules/es.array.for-each.js");

require("core-js/modules/web.dom-collections.for-each.js");

require("core-js/modules/es.object.get-own-property-descriptors.js");

require("core-js/modules/es.object.define-properties.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useInputStyles = exports.useLabelStyles = exports.useSelectStyles = void 0;

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.object.define-property.js");

var _core = require("../core");

var _utils = require("../utils");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var useSelectStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    root: function root(_ref) {
      var labelWidth = _ref.labelWidth;
      return _objectSpread(_objectSpread({
        height: '3rem',
        minWidth: (labelWidth !== null && labelWidth !== void 0 ? labelWidth : 0) + theme.spacing(9),
        // 2 (padding left) + 7 (padding right)
        boxSizing: 'border-box'
      }, theme.typography.body1), {}, {
        lineHeight: '16px',
        '&:hover, &:focus': {
          borderRadius: 'inherit',
          backgroundColor: 'inherit'
        },
        '&&': {
          paddingLeft: theme.spacing(2),
          paddingRight: theme.spacing(7),
          paddingTop: theme.spacing(2.75),
          paddingBottom: theme.spacing(1.25)
        }
      });
    },
    disabled: {
      '$root&': {
        color: theme.palette.text.disabled,
        '&:hover, &:focus': {
          borderRadius: 'unset',
          backgroundColor: 'unset'
        }
      }
    },
    noLabel: {
      '$root&&': {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
      }
    },
    small: {
      '$root&&': {
        height: '2.25rem',
        paddingTop: theme.spacing(1.25),
        paddingBottom: theme.spacing(1.25),
        fontSize: '14px'
      }
    },
    divider: {
      height: 'calc(100% + 1px)',
      width: '0.5px',
      position: 'absolute',
      right: theme.spacing(4.75)
    },
    icon: {
      right: theme.spacing(0.75)
    }
  };
}, {
  name: "".concat((0, _core.rochePrefix)('SelectDropdown'), "-select")
});
exports.useSelectStyles = useSelectStyles;
var useLabelStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    filled: {},
    filledOutlined: {},
    root: _objectSpread(_objectSpread({}, theme.typography.body1), {}, {
      color: theme.palette.text.secondary,
      '&$filled': {
        transform: "translate(".concat(theme.spacing(2), "px, ").concat(theme.spacing(1.5), "px) scale(1)")
      },
      '&$filledOutlined': {
        transform: "translate(".concat(theme.spacing(2) + 1, "px, ").concat(theme.spacing(1.5) + 1, "px) scale(1)")
      }
    }),
    disabled: {
      '&$filled': {
        color: theme.palette.text.disabled
      }
    },
    shrink: {
      '&$filled': {
        transform: "translate(".concat(theme.spacing(2), "px, ").concat(theme.spacing(0.75), "px) scale(0.75)")
      },
      '&$filledOutlined': {
        transform: "translate(".concat(theme.spacing(2) + 1, "px, ").concat(theme.spacing(0.75), "px) scale(0.75)")
      }
    }
  };
}, {
  name: "".concat((0, _core.rochePrefix)('SelectDropdown'), "-label")
});
exports.useLabelStyles = useLabelStyles;
var useInputStyles = (0, _utils.createStylesHook)()(function (theme) {
  return {
    focused: {},
    disabled: {},
    root: {
      borderRadius: theme.shape.borderRadius,
      backgroundColor: theme.palette.grey[100],
      '&:hover': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.grey[100], '#000000', 0.04),
        // Primary main 4% darker
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[100]
        }
      },
      '&$focused': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.grey[100], '#000000', 0.12) // Primary main 12% darker

      },
      '&$disabled': {
        backgroundColor: theme.palette.grey[100]
      }
    },
    filledOutlined: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid ".concat(theme.palette.grey['300']),
      '&:hover': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.background.paper, '#000000', 0.04),
        // Primary main 4% darker
        '@media (hover: none)': {
          backgroundColor: theme.palette.background.paper
        }
      },
      '&$focused': {
        backgroundColor: (0, _utils.hexMixColor)(theme.palette.background.paper, '#000000', 0.12) // Primary main 12% darker

      },
      '&$disabled': {
        backgroundColor: theme.palette.grey[100],
        borderColor: theme.palette.grey['400']
      }
    },
    adornedEnd: {
      paddingRight: 0
    }
  };
}, {
  name: "".concat((0, _core.rochePrefix)('SelectDropdown'), "-input")
});
exports.useInputStyles = useInputStyles;